import crispyOnionBurgerImg from "@img/homebackground.png";
import sizzlesImg from "@img/homebackground.png";
import caesarSaladImg from "@img/homebackground.png";

export const favorites = [
  {
    title: "CRISPY ONION BURGER",
    description:
      "Beef patty with Crispy Fried Onions, cheese, and Grove's mayo on a sesame seed bun.",
    img: crispyOnionBurgerImg,
  },
  {
    title: "SIZZLES",
    description:
      "Sautéed peppers and onions served on top of stir fried rice, mixed vegetables, and your choice of protein with a sauce of your choice drizzled on top.",
    img: sizzlesImg,
  },
  {
    title: "CAESAR SALAD",
    description:
      "Chopped romaine lettuce, parmesan cheese, and croutons tossed in a caesar dressing. You may also add protein of your choice!",
    img: caesarSaladImg,
  },
];

export const specials = [
  {
    title: "CRISPY ONION BURGER",
    description:
      "Beef patty with Crispy Fried Onions, cheese, and Grove's mayo on a sesame seed bun.",
    img: crispyOnionBurgerImg,
  },
  {
    title: "SIZZLES",
    description:
      "Sautéed peppers and onions served on top of stir fried rice, mixed vegetables, and your choice of protein with a sauce of your choice drizzled on top.",
    img: sizzlesImg,
  },
  {
    title: "CAESAR SALAD",
    description:
      "Chopped romaine lettuce, parmesan cheese, and croutons tossed in a caesar dressing. You may also add protein of your choice!",
    img: caesarSaladImg,
  },
];
